import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, httpAction } from '@/api/manage';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { queryUserTreeList } from '@/api/api';
import Vue from 'vue';
import { USER_INFO } from '@/store/mutation-types';
export default {
  name: 'comment',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      url: {
        comment: '/om/work/opinion/getByOrigin',
        addComment: '/om/work/opinion'
      },
      commentList: [],
      memo: '',
      userInfo: {},
      visibleUser: false,
      checkedKeys: [],
      treeData: [],
      selectUser: [],
      checkedRows: []
    };
  },
  props: {
    originId: {
      type: [Number, String]
    },
    originKey: {
      type: String,
      default: ''
    },
    startUser: {
      type: Object
    }
  },
  watch: {
    userInfo: {
      handler: function handler(val) {
        if (val && val.id && val.id != this.startUser.key) {
          this.selectUser = [{
            key: this.startUser.key,
            label: this.startUser.label
          }];
          this.checkedKeys = [this.startUser.key.toString()];
          this.checkedRows = _toConsumableArray(this.selectUser);
        } else {
          this.selectUser = [];
          this.checkedKeys = [];
          this.checkedRows = [];
        }
      },
      deep: true
    }
  },
  created: function created() {
    this.userInfo = Vue.ls.get(USER_INFO);
    this.loadComment();
    this.loadUser();
  },
  methods: {
    deleteUser: function deleteUser(key) {
      var _this = this;

      console.log('key', key);
      this.selectUser.forEach(function (item, i) {
        if (item.key == key) {
          _this.selectUser.splice(i, 1);
        }
      });
      this.checkedKeys.forEach(function (item, i) {
        if (item == key) {
          _this.checkedKeys.splice(i, 1);
        }
      });
      this.checkedRows.forEach(function (item, i) {
        if (item.key == key) {
          _this.checkedRows.splice(i, 1);
        }
      });
    },
    loadUser: function loadUser() {
      var _this2 = this;

      queryUserTreeList().then(function (res) {
        if (res.success) {
          _this2.treeData = res.result;

          if (_this2.startUser.key && _this2.startUser.key != _this2.userInfo.id) {
            _this2.setDisabled(_this2.treeData, [_this2.startUser.key]);
          }
        }
      });
    },
    handleChecked: function handleChecked(checkedKeys, row) {
      console.log('onCheck', row);
      this.checkedKeys = checkedKeys;
      this.checkedRows = row.checkedNodes.map(function (v) {
        return {
          key: v.data.props.value,
          label: v.data.props.label
        };
      });
    },
    openUser: function openUser() {
      this.visibleUser = true;
    },
    handleUser: function handleUser() {
      this.selectUser = _toConsumableArray(this.checkedRows);
      this.visibleUser = false;
    },
    handleCancelUser: function handleCancelUser() {
      this.visibleUser = false;
    },
    // 设置树禁用
    setDisabled: function setDisabled(treeData, list) {
      var _this3 = this;

      treeData.forEach(function (item) {
        if (item.children) {
          _this3.setDisabled(item.children, list);
        } else {
          list.forEach(function (userKey) {
            if (item.key == userKey) {
              item.disabled = true;
            }
          });
        }
      });
    },
    loadComment: function loadComment() {
      var _this4 = this;

      getAction(this.url.comment + '?originId=' + this.originId + '&originKey=' + this.originKey).then(function (res) {
        if (res.success) {
          _this4.commentList = res.result.reverse();
        }
      });
    },
    addComment: function addComment() {
      var param = {};
      param.originKey = this.originKey;
      param.originId = this.originId;
      param.opinion = this.memo;
      param.userId = this.selectUser.map(function (v) {
        return v.key;
      }).join(',');
      var that = this;
      httpAction(this.url.addComment, param, 'post').then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadComment();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      }).finally(function () {
        that.memo = '';

        if (that.startUser && that.startUser.key && that.startUser.key != that.userInfo.id) {
          that.selectUser = [{
            key: that.startUser.key,
            label: that.startUser.label
          }];
          that.checkedKeys = [that.startUser.key.toString()];
          that.checkedRows = [{
            key: that.startUser.key,
            label: that.startUser.label
          }];
        } else {
          that.selectUser = [];
          that.checkedKeys = [];
          that.checkedRows = [];
        }
      });
    },
    handleReply: function handleReply(item) {
      if (this.startUser.key == this.userInfo.id) {
        this.selectUser = [{
          key: item.createBy,
          label: item.createBy_userName
        }];
        this.checkedKeys = [item.createBy.toString()];
        this.checkedRows = [{
          key: item.createBy,
          label: item.createBy_userName
        }];
      } else {
        if (this.startUser.key == item.createBy) {
          this.selectUser = [{
            key: item.createBy,
            label: item.createBy_userName
          }];
          this.checkedKeys = [item.createBy.toString()];
          this.checkedRows = [{
            key: item.createBy,
            label: item.createBy_userName
          }];
        } else {
          this.selectUser = [{
            key: this.startUser.key,
            label: this.startUser.label
          }, {
            key: item.createBy,
            label: item.createBy_userName
          }];
          this.checkedKeys = [this.startUser.key.toString(), item.createBy.toString()];
          this.checkedRows = [{
            key: this.startUser.key,
            label: this.startUser.label
          }, {
            key: item.createBy,
            label: item.createBy_userName
          }];
        }
      }

      this.memo = '';
      document.documentElement.scrollTop = 0;
    }
  }
};